<li (click)="onClick()" class="line-item--base">
  {{ 'common.' + option | translate }}
</li>
